const v = require('valibot');

const targetOriginSchema = v.pipe(
  v.string(),
  v.trim(),
  v.nonEmpty('Enter the URL where your SPA is hosted'),
  v.url('Target SPA origin must be a valid URL'),
  v.check(value => {
    const url = new URL(value);
    return ['http:', 'https:'].includes(url.protocol) &&
      !url.username &&
      !url.password &&
      !url.search &&
      !url.hash;
  }, 'Target SPA origin must be an HTTP or HTTPS URL without credentials, query parameters, or fragments')
);

function validateTargetOrigin(value) {
  if (typeof value === 'string' && !value.trim()) {
    throw new Error('Enter the URL where your SPA is hosted');
  }

  let result;
  try {
    result = v.safeParse(targetOriginSchema, value);
  } catch (error) {
    throw new Error('Target SPA origin must be a valid URL');
  }

  if (!result.success) {
    const message = result.issues[0]?.message;
    throw new Error(message === 'Invalid URL'
      ? 'Target SPA origin must be a valid URL'
      : message || 'Target SPA origin must be a valid URL');
  }
  return result.output.replace(/\/$/, '');
}

module.exports = { targetOriginSchema, validateTargetOrigin };
